<template>
<div class="chapter">
<div class="inner_page">
<p><a id="epi"></a></p>
<div class="epiv">Firm ground is not available ground.</div>
<div class="eps"><i>—A. R. Ammons</i></div>
<div class="epiv"><div> <br/></div><div> <br/></div>I hear comments sometimes that large oil companies are greedy companies, or don’t care, but that is not the case in BP. We care about the small people.</div>
<div class="eps"><i>—Carl-Henric Svanberg, former chairman of BP</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318398_oeb_epi_r1.vue?610b0800